import React from "react";
import ComponentTemplateLibrary from "../../../../components/component-templates-library/ComponentTemplateLibrary";
import { TemplateSidebarProvider } from "../../../../contexts/ComponentTemplateSidebarContext";
import { EnableColorsContext } from "../../../../hooks/useEnableColors";
import { ComponentTemplateDialogProvider } from "../../../../contexts/ComponentTemplateDialogContext";
import { ComponentStatus } from "@growth-machine-llc/stridist-api-client";

interface CoachTemplateLibraryListProps {
  status: ComponentStatus;
}

export const CoachTemplateLibraryList = ({
  status,
}: CoachTemplateLibraryListProps) => {
  return (
    <TemplateSidebarProvider>
      <EnableColorsContext.Provider value={true}>
        <ComponentTemplateDialogProvider>
          <ComponentTemplateLibrary status={status} />
        </ComponentTemplateDialogProvider>
      </EnableColorsContext.Provider>
    </TemplateSidebarProvider>
  );
};

export const CoachComponentTemplateLibraryPublishedRoute = () => {
  return <CoachTemplateLibraryList status={ComponentStatus.PUBLISHED} />;
};

export const CoachComponentTemplateLibraryArchivedRoute = () => {
  return <CoachTemplateLibraryList status={ComponentStatus.ARCHIVED} />;
};
